import React from 'react'
import clsx from 'clsx'
import './VIPBadge.scss'
import { ZinIcon } from '@tnl/zin-react'

export interface VIPBadgeProps {
  /** The text content to display in the badge */
  label: string
  /** Whether the badge is interactive (clickable) */
  isInteractive?: boolean
  /** Callback function when badge is clicked (only used when isInteractive is true) */
  onToggle?: () => void
  /** Additional CSS classes */
  className?: string
  isOpen?: boolean
}

/**
 * VIPBadge component displays a styled badge with VIP styling.
 * Can be interactive (clickable) or static based on the isInteractive prop.
 */
export const VIPBadge: React.FC<VIPBadgeProps> = ({ label, isInteractive = false, onToggle, className, isOpen }) => {
  const handleClick = () => {
    if (isInteractive && onToggle) {
      onToggle()
    }
  }

  const badgeClasses = clsx(
    'vip-badge caption-2',
    {
      'vip-badge--interactive': isInteractive,
    },
    className,
  )

  if (isInteractive) {
    return (
      <button
        type="button"
        className={badgeClasses}
        onClick={handleClick}>
        {label}
        <ZinIcon
          name={isOpen ? 'chevron-up' : 'chevron-down'}
          size="tiny"
        />
      </button>
    )
  }

  return <span className={badgeClasses}>{label}</span>
}
